import React, { useEffect, useState } from "react";
import {
  Box,
  Flex,
  Text,
  Button,
  VStack,
  Avatar,
  HStack,
  Badge,
  IconButton,
  Image,
  SlideFade,
  CloseButton,
  useColorModeValue,
  Divider,
  Grid,
  Icon,
  Heading,
  Stack,
} from "@chakra-ui/react";
import { EditIcon, CheckIcon, CloseIcon } from "@chakra-ui/icons";
import {
  FaUserGraduate,
  FaChalkboardTeacher,
  FaClipboardList,
} from "react-icons/fa";
import { FaPlus, FaSync, FaPrint } from "react-icons/fa";
import { MdPayment, MdAccessTime, MdAssessment, MdClass } from "react-icons/md";
import { Doughnut, Bar } from "react-chartjs-2";
import "chart.js/auto";
// import "react-calendar/dist/Calendar.css";
import { Link } from "react-router-dom";
import CardSlider from "./Slider";
import { useNavigate } from "react-router-dom";
import NoticeBoard from "./NoticeBoard";
import TodoList from "./Todo";
import StudentActivity from "./Activity";
import axios from "axios";
import Icons from "../../images/company logo.jpg";

import Calendar from "../Event/Event_Create_View/Calender";
import Calender_events_small from "./Calender_events_small";
import { BASE_URL } from "../../Globalapi/Globalapi";

const DashboardCard = ({
  icon,
  count,
  title,
  active,
  inactive,
  percentage,
  colorScheme,
}) => {
  return (
    <Box
      bg="white"
      p={4}
      borderRadius="md"
      boxShadow="md"
      minW="300px"
      maxW="100%"
      textAlign="center"
      _hover={{
        transform: "translateY(-4px)",
        transition: "0.2s ease",
        boxShadow: "md",
      }}
    >
      {/* Top Section */}
      <Flex justifyContent="space-between" alignItems="center" mb={2}>
        {/* Icon */}
        <Avatar bg={`${colorScheme}.50`} src={icon} size="md" />

        {/* Count + Title */}
        <VStack spacing={0}>
          <Text
            fontSize="3xl"
            fontWeight="bold"
            color="gray.700"
            lineHeight="1"
          >
            {count}
          </Text>
          <Text fontSize="sm" color="gray.500" fontWeight="medium">
            {title}
          </Text>
        </VStack>

        {/* Percentage Badge */}
        <Box
          bg={`${colorScheme}.50`}
          borderRadius="md"
          px={3}
          py={1}
          minW="50px"
          textAlign="center"
        >
          <Text
            fontSize="sm"
            fontWeight="semibold"
            color={`${colorScheme}.700`}
          >
            {percentage}%
          </Text>
        </Box>
      </Flex>

      <Divider />

      {/* Bottom Section */}
      <HStack justifyContent="space-between" mt={2}>
        <Text fontSize="sm" color="#2c9c9c">
          Active: <strong>{active}</strong>
        </Text>
        <Text fontSize="sm" color="#6366F1">
          Inactive: <strong>{inactive}</strong>
        </Text>
      </HStack>
    </Box>
  );
};

const ProfileCard = () => {
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);

  const [date, setDate] = useState(new Date());
  const [timetableData, setTimetableData] = useState([]);
  const [studentId] = useState(2);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const userId = sessionStorage.getItem("user_id"); // Retrieve user ID from session
  const userType = sessionStorage.getItem("user_type");
  const [schoolDetailes, setSchoolDetailes] = useState({});
  const [students, setStudents] = useState([]);
  const [boysCount, setBoysCount] = useState(0);
  const [girlsCount, setGirlsCount] = useState(0);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const school_id = sessionStorage.getItem("school_id");

  const fetchStudents = async () => {
    try {
      const jwt = sessionStorage.getItem("jwt");
      const response = await axios.get(
        `${BASE_URL}/admin/student/list_all_student.php?school_id=${school_id}`,
        {
          headers: {
            Authorization: `Bearer ${jwt}`,
          },
        }
      );
      setStudents(response.data.data || []);
      setIsDataLoaded(true);
      console.log("studentd list:", response.data.data);
    } catch (error) {
      console.error("Error fetching students:", error);
      setError("Error fetching students");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStudents();
  }, []);

  const calculateGenderDistribution = (studentList) => {
    if (!studentList || studentList.length === 0) {
      setBoysCount(0);
      setGirlsCount(0);
      return;
    }

    const maleCount = studentList.filter(
      (student) => student.gender_id && student.gender_id === "1"
    ).length;

    const femaleCount = studentList.filter(
      (student) => student.gender_id && student.gender_id === "2"
    ).length;

    setBoysCount(maleCount);
    setGirlsCount(femaleCount);
  };

  useEffect(() => {
    calculateGenderDistribution(students);
  }, [students]);

  const genderData = {
    labels: ["Boys", "Girls"],
    datasets: [
      {
        data: [boysCount, girlsCount],
        backgroundColor: ["#ADD8E6", "#FFB6C1"],
        hoverBackgroundColor: ["#87CEEB", "#FF69B4"],
      },
    ],
  };

  // Dummy data for the bar chart (total student and staff count)
  const totalStudentCount = 500; // Replace with actual total student count
  const totalStaffCount = 50; // Replace with actual total staff count

  // New data breakdowns
  const studentsPerGrade = [100, 120, 130, 150]; // Example: students in Grade 1, 2, 3, 4
  const staffPerRole = [30, 10, 10]; // Example: Teachers, Administrators, Support Staff
  const maleStaffCount = 30; // Male staff
  const femaleStaffCount = 20; // Female staff

  const leaveRequests = [
    {
      name: "James",
      role: "Physics Teacher",
      leaveType: "Emergency",
      leaveDates: "12-13 May",
      applyDate: "12 May",
      avatar: "https://randomuser.me/api/portraits/men/1.jpg", // Replace with appropriate image
    },
    {
      name: "Ramien",
      role: "Accountant",
      leaveType: "Casual",
      leaveDates: "12-13 May",
      applyDate: "11 May",
      avatar: "https://randomuser.me/api/portraits/men/2.jpg", // Replace with appropriate image
    },
  ];

  useEffect(() => {
    const fetchSchoolData = async () => {
      try {
        const school_id = sessionStorage.getItem("school_id");
        console.log("school id in school select:", school_id);
        if (!school_id) {
          alert("No school_id found in session storage.");
          return;
        }

        const response = await axios.get(
          `${BASE_URL}/admin/school/select_school.php`,
          {
            params: {
              school_id: school_id,
            },
          }
        );

        const data = response.data.data;
        setSchoolDetailes(data);

        // Save to sessionStorage
        if (data) {
          sessionStorage.setItem("school_image_url", data.image_url);
          sessionStorage.setItem("school_address", data.s_address);
          sessionStorage.setItem("school_email", data.s_email);
          sessionStorage.setItem("school_name", data.s_name);
        }
      } catch (error) {
        console.error("error occurred in fetch school result:", error);
      }
    };

    fetchSchoolData();
  }, []);

  useEffect(() => {
    const fetchTimetable = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/admin/timetable/list_timetable_to_student.php`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ student_id: studentId }),
          }
        );
        const data = await response.json();
        if (data.success) {
          setTimetableData(data.timeTable || []);
        }
        console.log("time table:", data);
        // } else {
        //   console.log("Error fetching timetable:", data.message);
        // }
      } catch (error) {
        console.error("Error fetching timetable:", error);
      }
    };

    fetchTimetable();
  }, [studentId]);

  const data = {
    labels: ["Q1: 2023", "Q2: 2023", "Q3: 2023", "Q4: 2023", "Q5: 2023"],
    datasets: [
      {
        label: "Collected Fee",
        data: [50, 60, 40, 80, 70],
        backgroundColor: "#3182CE",
      },
      {
        label: "Total Fee",
        data: [100, 100, 100, 100, 100],
        backgroundColor: "#E2E8F0",
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: false,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
      },
    },
    barThickness: 50,
  };

  const handleClick = () => {
    navigate("/students/add"); // Navigate to the desired route
  };

  const handleonClick = () => {
    navigate("/teachers/add"); // Navigate to the desired route
  };

  const [counts, setCounts] = useState({
    student_count: 0,
    staff_count: 0,
    subject_count: 0,
    class_count: 0,
  });

  useEffect(() => {
    // Fetch the data from API once
    axios
      .get(`${BASE_URL}/admin/graphs/total_counts.php`)
      .then((response) => {
        console.log("total@@", response);
        if (response.data.success) {
          setCounts(response.data.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching counts:", error);
      });
  }, []);
  // const studentImage = require("./student.jpg");
  const [sectionWiseData, setSectionWiseData] = useState([]);
  const [genderWiseData, setGenderWiseData] = useState([]);
  useEffect(() => {
    // Fetch the data from API
    axios
      .get(`${BASE_URL}/admin/graphs/total_counts.php`)
      .then((response) => {
        if (response.data.success) {
          setSectionWiseData(response.data.data.section_wise_count);
          setGenderWiseData(response.data.data.gender_wise_count);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await fetch(`${BASE_URL}/student/all_profile.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ user_type: userType, user_id: userId }),
        });

        if (!response.ok) throw new Error("Network response was not ok");
        const data = await response.json();
        setUserData(data.data);
        console.log("====================================");
        console.log("profile", data.data);
        console.log("====================================");
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };
    fetchUserData();
  }, [userType, userId]);
  // Prepare the labels and data arrays
  const sectionLabels = sectionWiseData.map((item) => item.section);
  const sectionCounts = sectionWiseData.map((item) =>
    parseInt(item.section_student_count, 10)
  );

  const genderLabels = genderWiseData.map((item) => item.gender);
  const genderCounts = genderWiseData.map((item) => parseInt(item.count, 10));
  const studentStaffData = {
    labels: [...sectionLabels, ...genderLabels], // Merged section and gender labels
    datasets: [
      {
        label: "Count",
        data: [...sectionCounts, ...genderCounts], // Merged section and gender counts
        backgroundColor: [
          "#3182CE",
          "#63B3ED",
          "#4299E1",
          "#2B6CB0", // Different shades of blue for sections
          "#48BB78",
          "#68D391", // Green shades for gender counts
        ],
      },
    ],
  };
  const bg = useColorModeValue("green.50", "green.900");
  const borderColor = useColorModeValue("green.400", "green.500");

  const boxShadow = useColorModeValue("md", "lg");

  const quickLinks = [
    {
      label: "All Students",
      icon: FaUserGraduate,
      bgColor: "green.50",
      iconColor: "green.400",
      route: "/students/all",
    },
    {
      label: "All Teachers",
      icon: FaChalkboardTeacher,
      bgColor: "yellow.50",
      iconColor: "yellow.400",
      route: "/teachers/all",
    },
    {
      label: "Time Table",
      icon: MdAccessTime,
      bgColor: "cyan.50",
      iconColor: "cyan.400",
      route: "/timetable/create",
    },
    // {
    //   label: "Fees",
    //   icon: MdPayment,
    //   bgColor: "cyan.50",
    //   iconColor: "cyan.400",
    //   route: "/fees",
    // },
    {
      label: "Year",
      icon: MdPayment,
      bgColor: "cyan.50",
      iconColor: "cyan.400",
      route: "/academic_year",
    },
    {
      label: "Class",
      icon: MdClass,
      bgColor: "teal.50",
      iconColor: "teal.400",
      route: "/class",
    },
    {
      label: "Exam ",
      icon: MdAssessment,
      bgColor: "gray.50",
      iconColor: "gray.400",
      route: "/exam/detail",
    },
  ];
  // bg="#FBFBFD"
  // "#FBFBFD"
  return (
    <Box bg="gray.200" minHeight="100vh" p={5}>
      <div style={{ backgroundColor: "#F9FAFB" }}>
        <div className="teacher-list-container">
          <div className="header">
            <h1 fontSize="20px">Admin Dashboard</h1>

            <Flex
              gap={{ base: 2, md: 4 }} // Smaller gap on mobile
              align="center"
            >
              {/* Refresh Button - Keep hidden on small screens if it clutters the interface */}
              <Button
                borderRadius="md"
                p={{ base: 2, md: 3 }} // Smaller padding on mobile
                minW={{ base: "30px", md: "auto" }} // Fixed min width on mobile for circular look (if p=2, it'll be close to square/circle)
                bg="white"
                border="1px solid"
                borderColor="gray.200"
                boxShadow="sm"
                _hover={{
                  bg: "gray.50",
                }}
                onClick={() => console.log("Refresh button clicked")}
                // Only display on medium screens and up
                display={{ base: "none", md: "flex" }}
              >
                <FaSync size={16} color="#2c9c9c" />
              </Button>

              {/* Add Teacher */}
              <Button
                bg="teal.300"
                color="white"
                borderRadius="md"
                leftIcon={<FaPlus />}
                // Smaller font and padding on mobile for space saving
                fontSize={{ base: "xs", md: "sm" }}
                px={{ base: 3, md: 5 }}
                py={{ base: 2, md: "initial" }}
                height={{ base: "30px", md: "40px" }} // Set a fixed height for mobile
                _hover={{
                  bg: "teal.600",
                  transform: "translateY(-2px)",
                  boxShadow: "md",
                }}
                onClick={handleonClick}
              >
                {/* Only display the text on medium screens and up, leaving only the icon on small screens */}
                <Box as="span" display={{ base: "none", sm: "block" }}>
                  Add Teacher
                </Box>
              </Button>

              {/* Add Student */}
              <Button
                bg="teal.300"
                color="white"
                borderRadius="md"
                leftIcon={<FaPlus />}
                fontSize={{ base: "xs", md: "sm" }}
                px={{ base: 3, md: 5 }}
                py={{ base: 2, md: "initial" }}
                height={{ base: "30px", md: "40px" }} // Set a fixed height for mobile
                _hover={{
                  bg: "teal.600",
                  transform: "translateY(-2px)",
                  boxShadow: "md",
                }}
                onClick={handleClick}
              >
                <Box as="span" display={{ base: "none", sm: "block" }}>
                  Add Student
                </Box>
              </Button>
            </Flex>
          </div>
        </div>
        <Box p={{ base: 0, md: 6 }}>
          {/* <Box p={4}>
            <Flex
              alignItems="center"
              justifyContent="space-between"
              p={2}
              bg={bg}
              borderWidth="1px"
              borderColor={borderColor}
              borderRadius="full"
            >
              <Flex alignItems="center">
                <Avatar
                  size="sm"
                  src={Icons} // Replace with actual avatar URL or remove for a default avatar
                  mr={3}
                />
                <Box>
                  <Text fontSize="sm">
                    <Text as="span" fontWeight="bold" color="green">
                      Empowering businesses with tailored tech solutions
                    </Text>{" "}
                  </Text>
                </Box>
              </Flex>
              <CloseButton />
            </Flex>
          </Box> */}
          <Box>
            <Flex
              align="center"
              justify="space-between"
              backdropFilter="blur(12px)" // glass effect
              bg="rgba(59, 130, 246, 0.08)" // light transparent blue (adjust opacity)
              border="1px solid"
              borderColor="blue.300" // distinct border color
              borderRadius="lg"
              // boxShadow="md"
              p={4}
              gap={4}
              transition="all 0.3s ease"
              _hover={{
                // boxShadow: "xl",
                transform: "translateY(-3px)",
              }}
            >
              {/* Left Section */}
              <Flex align="center" gap={3}>
                <Avatar
                  size="md"
                  src={Icons}
                  name="Tech Solutions"
                  // border="2px solid"
                  borderColor="teal.100"
                />
                <Box>
                  <Text fontSize="sm" color="gray.700">
                    <Text as="span" fontWeight="bold" color="teal.500">
                      Empowering businesses
                    </Text>{" "}
                    with tailored tech solutions
                  </Text>
                </Box>
              </Flex>

              {/* Right Section */}
              <CloseButton
                size="sm"
                color="gray.600"
                _hover={{ bg: "gray.200", transform: "rotate(90deg)" }}
                transition="all 0.3s ease"
              />
            </Flex>
          </Box>

          {/* <Box p={4}>
            <Box
              bgGradient="linear(to-r, blue.600, blue.500)"
              p={4}
              borderRadius="lg"
              color="white"
              position="relative"
              maxH={{ base: "auto", md: "177px" }} // Set to auto on mobile
              overflow="hidden"
            >
              <Flex
                direction={{ base: "column", md: "row" }} // Stack vertically on mobile
                alignItems={{ base: "start", md: "center" }} // Align start on mobile
              >
                <Avatar
                  size="2xl"
                  name={userData?.S_name}
                  src={
                    userData?.image_url ||
                    "https://t4.ftcdn.net/jpg/02/29/75/83/360_F_229758328_7x8jwCwjtBMmC6rgFzLFhZoEpLobB6L8.jpg"
                  }
                  mr={6}
                />
                <VStack align="start" spacing={2}>
                  <Text fontWeight="bold" fontSize="2xl">
                    Welcome Back, {userData?.s_name}
                  </Text>
                  <Text fontSize="lg">{userData?.name}</Text>
                  <Text fontSize="lg">Admin</Text>
                </VStack>
                <Button
                  leftIcon={<EditIcon />}
                  colorScheme="whiteAlpha"
                  variant="outline"
                  position="absolute"
                  top={4}
                  right={4}
                >
                  Edit Profile
                </Button>
              </Flex>
            </Box>
          </Box> */}
          <Box py={4}>
            <Box
              // bgGradient="linear(to-r, orange.300, pink.300)"
              // backdropFilter="blur(12px)"
              // border="1px solid"
              borderColor="gray.300"
              p={6}
              bg="white"
              borderRadius="md"
              color="white"
              position="relative"
              shadow="md"
              maxH={{ base: "auto", md: "200px" }}
              // boxShadow="md"
              _hover={{
                transform: "scale(1.01)",
                transition: "0.3s ease-in-out",
              }}
            >
              <Flex
                direction={{ base: "column", md: "row" }}
                alignItems={{ base: "start", md: "center" }}
                gap={6}
              >
                <Avatar
                  size="lg"
                  name={userData?.name}
                  src={
                    userData?.image_url
                    // ||"https://t4.ftcdn.net/jpg/02/29/75/83/360_F_229758328_7x8jwCwjtBMmC6rgFzLFhZoEpLobB6L8.jpg"
                  }
                  border="1px solid black"
                  boxShadow="md"
                />

                <VStack align="start" spacing={1} flex={1}>
                  <Text
                    fontWeight="bold"
                    fontSize="2xl"
                    letterSpacing="wide"
                    color="black"
                  >
                    Welcome Back, {userData?.s_name}
                  </Text>
                  <Text fontSize="lg" color="whiteAlpha.900">
                    {userData?.name}
                  </Text>
                  <Box
                    bg="#63B3ED"
                    px={3}
                    py={1}
                    borderRadius="sm"
                    fontSize="sm"
                    fontWeight="semibold"
                    color=""
                  >
                    Admin
                  </Box>
                </VStack>

                <Button
                  leftIcon={<EditIcon />}
                  colorScheme="whiteAlpha"
                  variant="solid"
                  bg="whiteAlpha.300"
                  _hover={{ bg: "whiteAlpha.500" }}
                >
                  Edit Profile
                </Button>
              </Flex>
            </Box>
          </Box>

          <Flex
            justifyContent="space-around"
            flexWrap="wrap"
            gap={7}
            p={8}
            style={{
              paddingLeft: "0px",
              paddingRight: "0px",
              paddingTop: "6px",
            }}
          >
            <DashboardCard
              icon="https://img.icons8.com/color/96/000000/student-male--v1.png"
              count={counts.student_count}
              title="Total Students"
              active={counts.student_count} // Example active count, update with correct logic
              inactive={0} // Example inactive count
              percentage="1.2"
              colorScheme="red"
            />
            <DashboardCard
              icon="https://img.icons8.com/color/96/000000/teacher.png"
              count={counts.staff_count}
              title="Total Teachers"
              active={counts.staff_count} // Example active count, update with correct logic
              inactive={0} // Example inactive count
              percentage="1.2"
              colorScheme="blue"
            />
            <DashboardCard
              icon="https://img.icons8.com/color/96/000000/conference-call.png"
              count={counts.class_count} // Update if staff and teachers are separate
              title="Total Class"
              active={counts.class_count} // Example active count, update with correct logic
              inactive={0} // Example inactive count
              percentage="1.2"
              colorScheme="yellow"
            />
            <DashboardCard
              icon="https://img.icons8.com/color/96/000000/book.png"
              count={counts.subject_count}
              title="Total Subjects"
              active={counts.subject_count} // Example active count, update with correct logic
              inactive={0} // Example inactive count
              percentage="1.2"
              colorScheme="green"
            />
          </Flex>
          <Flex gap={4} mb={6} direction={{ base: "column", md: "row" }}>
            {/* Left Side */}
            <Flex direction="column" flex="2" gap={6}>
              {/* Profile Section */}

              {/* Timetable with Bar Chart */}
              <Box display={{ base: "none", md: "block" }}>
                <Box
                  bg="white"
                  p={6}
                  borderRadius="md"
                  overflowY="auto"
                  // borderWidth="1px"
                  shadow="md"
                >
                  <Text fontWeight="bold" fontSize="lg" mb={4}>
                    Total Students and Staff Breakdown
                  </Text>
                  <div style={{ width: "100%", height: "300px" }}>
                    {" "}
                    {/* Set a specific height for the chart */}
                    <Bar
                      data={studentStaffData}
                      options={{
                        responsive: true,
                        maintainAspectRatio: false, // Disable the default aspect ratio
                        scales: {
                          x: {
                            ticks: {
                              color: "#4A5568", // Adjust label color (optional)
                            },
                            grid: {
                              display: false, // Hide the gridlines for cleaner look
                            },
                          },
                          y: {
                            ticks: {
                              color: "#4A5568",
                            },
                            grid: {
                              color: "#E2E8F0", // Adjust grid color for cleaner look
                            },
                          },
                        },
                        plugins: {
                          legend: {
                            display: true,
                            labels: {
                              color: "#4A5568", // Change the color of the legend text
                            },
                          },
                        },
                        barThickness: 40, // Adjust this value to make bars thinner
                        maxBarThickness: 50, // Maximum width of bars
                      }}
                    />
                  </div>
                </Box>
              </Box>

              <Box display={{ base: "none", md: "block" }}>
                <Box
                  p={5}
                  bg="white"
                  // borderWidth="1px"
                  borderRadius="md"
                  shadow="md"
                  // mt={4}
                >
                  <Flex justifyContent="space-between" mb={3}>
                    <Text fontSize="lg" fontWeight="bold">
                      Fees Collection
                    </Text>
                    <Text fontSize="sm" color="gray.500">
                      Last 8 Quarters
                    </Text>
                  </Flex>
                  <div style={{ width: "100%", height: "300px" }}>
                    {" "}
                    {/* Set height for the second chart */}
                    <Bar
                      data={data}
                      options={{
                        responsive: true,
                        maintainAspectRatio: false, // Disable default aspect ratio to manually control height
                        scales: {
                          x: {
                            ticks: {
                              color: "#4A5568",
                            },
                            grid: {
                              display: false,
                            },
                          },
                          y: {
                            ticks: {
                              color: "#4A5568",
                            },
                            grid: {
                              color: "#E2E8F0",
                            },
                          },
                        },
                        plugins: {
                          legend: {
                            display: true,
                            labels: {
                              color: "#4A5568",
                            },
                          },
                        },
                        barThickness: 40,
                        maxBarThickness: 50,
                      }}
                    />
                  </div>
                </Box>
              </Box>

              <Stack
                spacing={4}
                direction={{ base: "column", md: "row" }}
                align="start"
              >
                <Box
                  flex="1"
                  width={{ base: "100%", md: "auto" }} // Full width on mobile, auto on larger screens
                >
                  <NoticeBoard />
                </Box>
                <Box
                  flex="1"
                  maxW="366px"
                  display={{ base: "none", md: "block" }}
                >
                  <CardSlider />
                </Box>
              </Stack>
              <Stack
                spacing={4}
                direction={{ base: "column", md: "row" }}
                align="start"
              >
                <Box flex="2">
                  <TodoList />
                </Box>
                <Box flex="1">
                  <StudentActivity />
                </Box>
              </Stack>
            </Flex>

            {/* Right Side */}
            <Flex direction="column" flex="1" gap={8}>
              <Box
                p={9}
                maxW={{ base: "full", md: "lg" }} // Adjust the max width for mobile
                borderRadius="md"
                // borderWidth="1px"
                bg="white"
                shadow="md"
              >
                <Heading fontSize="lg" mb={3}>
                  Quick Links
                </Heading>
                <Divider />
                <Grid
                  templateColumns={{
                    base: "repeat(2, 1fr)", // 2 columns for smaller screens
                    md: "repeat(3, 1fr)", // 3 columns for medium screens and above
                  }}
                  gap={4}
                  mt={4}
                >
                  {quickLinks.map((link, index) => (
                    <Link to={link.route} key={index}>
                      <Box
                        bg={link.bgColor}
                        p={4}
                        borderRadius="md"
                        textAlign="center"
                        boxShadow={boxShadow}
                        _hover={{
                          transform: "scale(1.05)",
                          transition: "0.2s",
                        }}
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                      >
                        <Flex
                          alignItems="center"
                          justifyContent="center"
                          mb={2}
                          borderRadius="full"
                          w={12}
                          h={12}
                          border="1px"
                          borderColor={link.iconColor}
                          bg={link.iconColor + "20"} // Light background for the icon
                        >
                          <Icon
                            as={link.icon}
                            w={6}
                            h={6}
                            color={link.iconColor}
                          />
                        </Flex>
                        <Text fontWeight="semibold">{link.label}</Text>
                      </Box>
                    </Link>
                  ))}
                </Grid>
              </Box>

              <Box shadow="md">
                <Calender_events_small />
              </Box>

              {/* Gender Distribution */}

              <Box p={5} bg="white" borderWidth="1px" borderRadius="md">
                <Flex justifyContent="space-between" mb={3}>
                  <Text fontSize="lg" fontWeight="bold">
                    Leave Requests
                  </Text>
                  <Text fontSize="sm" color="gray.500">
                    Today
                  </Text>
                </Flex>

                {leaveRequests.map((request, index) => (
                  <Box
                    key={index}
                    p={4}
                    mb={4}
                    border="1px solid"
                    borderColor="gray.200"
                    borderRadius="md"
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Flex alignItems="center">
                      <Avatar
                        src={request.avatar}
                        name={request.name}
                        size="md"
                        mr={4}
                      />
                      <Box>
                        <Text fontWeight="bold">{request.name}</Text>
                        <Badge
                          colorScheme={
                            request.leaveType === "Emergency" ? "red" : "yellow"
                          }
                        >
                          {request.leaveType}
                        </Badge>
                        <Text color="gray.500">{request.role}</Text>
                        <Text mt={2}>
                          Leave: <b>{request.leaveDates}</b>
                        </Text>
                      </Box>
                    </Flex>

                    <Box textAlign="right">
                      <Text mb={2} color="gray.500">
                        Apply on: <b>{request.applyDate}</b>
                      </Text>
                      <Flex>
                        <IconButton
                          icon={<CheckIcon />}
                          colorScheme="green"
                          aria-label="Approve"
                          mr={2}
                        />
                        <IconButton
                          icon={<CloseIcon />}
                          colorScheme="red"
                          aria-label="Reject"
                        />
                      </Flex>
                    </Box>
                  </Box>
                ))}
              </Box>

              <Box bg="white" p={6} borderRadius="lg" borderWidth="1px">
                <Text fontWeight="bold" fontSize="lg" mb={4}>
                  Gender Distribution
                </Text>
                <div style={{ height: "375px" }}>
                  {boysCount + girlsCount > 0 ? (
                    <Doughnut data={genderData} />
                  ) : (
                    <Text textAlign="center" color="gray.500" mt={10}>
                      {loading
                        ? "Loading student data..."
                        : "No student data available to display gender distribution."}
                    </Text>
                  )}{" "}
                </div>
              </Box>
            </Flex>
          </Flex>
        </Box>
      </div>
    </Box>
  );
};

export default ProfileCard;
